import { getFileType } from './fileTypeUtils';

const IMAGE_EXTENSIONS = ['bmp', 'jpg', 'jpeg', 'png', 'gif', 'webp', 'ico', 'svg', 'avif'];
const VIDEO_EXTENSIONS = ['mp4', 'm4v', 'mov', 'webm', 'avi', 'mkv', 'flv', 'wmv', 'mpeg', 'mpg', '3gp', 'ts', 'm2ts', 'ogv'];
const AUDIO_EXTENSIONS = ['mp3', 'm4a', 'aac', 'wav', 'flac', 'ogg', 'oga', 'opus', 'wma', 'amr', 'aiff', 'aif', 'mid', 'midi'];

export const isMufySupportedImage = (fileName = '', contentType = '') => {
  const normalizedContentType = contentType.toLowerCase();
  if (normalizedContentType.startsWith('image/')) {
    return true;
  }

  const extension = getFileType('', fileName);
  return IMAGE_EXTENSIONS.includes(extension);
};

export const isMufySupportedMediaDirectLink = (fileName = '', contentType = '') => {
  const normalizedContentType = contentType.toLowerCase();
  if (normalizedContentType.startsWith('video/') || normalizedContentType.startsWith('audio/')) {
    return true;
  }

  const extension = getFileType('', fileName);
  return VIDEO_EXTENSIONS.includes(extension) || AUDIO_EXTENSIONS.includes(extension);
};
